import { graphql } from "@opensea/graphql"

export const AccountEnforcementBadgeFragment = graphql(`
  fragment AccountEnforcementBadge on Profile {
    isCompromised
  }
`)
